<template>
  <div class="details">
    <div class="title">{{ title }}</div>
    <div class="info">
      <div class="info-time">{{ time }}</div>
      <!-- <div class="info-look">{{ viewLook }}人已看</div> -->
    </div>
    <div class="content" v-html="content"></div>
    <div class="file" v-if="ossUrl">
      <div class="file-name">点击下载行业报告全文</div>
      <div class="file-btn" @click="downTap">
        <van-icon name="back-top" />
        <span>下载</span>
      </div>
    </div>
    <div class="link" v-if="link">点击此处查看<span @click="linkTap">原文链接</span></div>
  </div>
</template>
<script>
import { detail } from '@api/servicebus/servicebus'
import { Toast } from 'vant'
export default {
  data() {
    return {
      title: '', // 标题
      time: '', // 发布时间
      viewLook: 0, // 查看人数
      content: '', // 正文内容
      ossUrl: '', // 行业报告下载链接
      link: '' // 原文链接
    }
  },
  mounted() {
    const params = {
      id: this.$route.query.id,
      type: this.$route.query.type
    }
    detail(params).then(res => {
      const { code, data, msg } = res.data
      if (code == '0000') {
        this.title = data.title
        this.time = '发布时间：' + data.time
        this.content = data.text
        this.link = data.url
      } else {
        Toast(msg)
      }
    })
  },
  methods: {
    downTap() {
      window.open(this.ossUrl)
    },
    linkTap() {
      window.open(this.link)
    }
  }
}
</script>
<style lang="scss" scoped>
.details {
  padding: 15px;
}
.title {
  font-size: 24px;
  font-weight: bold;
  padding: 15px 0 10px;
}
.info {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 0 20px;
  border-bottom: 1px solid #eee;
  &-time {
    font-size: 12px;
    color: #999;
  }
  &-look {
    font-size: 12px;
    color: #999;
    background: #eee;
    padding: 2px 10px;
    border-radius: 30px;
  }
}
.content {
  font-size: 14px;
  color: #333;
  padding: 15px 0;
}
.file {
  width: 90%;
  margin: 0 auto;
  padding: 6px 10px;
  border: 1px solid #ccc;
  display: flex;
  align-items: center;
  justify-content: space-between;
  &-name {
    font-size: 14px;
    color: #333;
  }
  &-btn {
    width: 60px;
    height: 30px;
    line-height: 26px;
    background: linear-gradient(
      to right,
      rgba(51, 153, 255, 1),
      rgba(51, 105, 255, 1)
    );
    text-align: center;
    border-radius: 4px;
    .van-icon {
      transform: rotate(180deg);
      font-size: 16px;
      color: #fff;
      vertical-align: middle;
    }
    span {
      font-size: 14px;
      color: #fff;
      vertical-align: middle;
    }
  }
}
.btinfo {
  margin-top: 20px;
  &-source {
    text-align: right;
    font-size: 12px;
    color: #999;
    line-height: 20px;
    span {
      color: #333;
    }
  }
}
.link {
  font-size: 14px;
  color: #333;
  margin-top: 20px;
  span {
    color: #336bff;
  }
}
</style>
